import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Button } from '../primitives/Button';
import { ThemeContext } from '../theme/theme-context';
const LOGOUT_LABEL = { de: 'Abmelden', en: 'Sign out' };
/**
 * Konto-Menue rechts in der App-Shell: angemeldeter Nutzer (E-Mail/Name) mit
 * optionalem Rollen-Zusatz plus Logout-Button. Typischerweise im
 * `profile`-Slot von `<AppShell>` platziert.
 */
export function AccountMenu({ label, secondary, title, onLogout, logoutLabel, logoutIcon, logoutAriaLabel, }) {
    const theme = useContext(ThemeContext);
    const text = logoutLabel ?? LOGOUT_LABEL[theme?.language ?? 'de'];
    return (_jsxs("span", { className: "sec-account-menu", children: [_jsxs("span", { className: "sec-account-menu__label", title: title, children: [label, secondary ? ` · ${secondary}` : ''] }), _jsx(Button, { variant: "ghost", size: "sm", icon: Boolean(logoutIcon), onClick: onLogout, "aria-label": logoutIcon ? logoutAriaLabel ?? text : undefined, children: logoutIcon ?? text })] }));
}
